// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var nTimes = function (dictMonad) {
    return function (i) {
        return function (f) {
            if (i > 0) {
                return Control_Bind.bind(dictMonad.Bind1())(f)(function (v) {
                    return Control_Bind.bind(dictMonad.Bind1())(nTimes(dictMonad)(i - 1 | 0)(f))(function (v1) {
                        return Control_Applicative.pure(dictMonad.Applicative0())(Data_Array.cons(v)(v1));
                    });
                });
            };
            if (Data_Boolean.otherwise) {
                return Control_Applicative.pure(dictMonad.Applicative0())([  ]);
            };
            throw new Error("Failed pattern match at Ritoppu.Utils (line 7, column 1 - line 7, column 61): " + [ i.constructor.name, f.constructor.name ]);
        };
    };
};
module.exports = {
    nTimes: nTimes
};
